import { Component } from '@angular/core';
import { AddinView } from '@techwan/ionic-core';

@Component({
  templateUrl: 'generic.component.html',
  styleUrls: ['generic.component.scss']
})
@AddinView({
  name: 'generic'
})
export class GenericHomeComponent {
  constructor() {}
}
